import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { logout } from '../actions/user';
import NoAccess from '../components/NoAccess';

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
};

const mapStateToProps = ({ ui }) => ({
  invertedTheme: ui.invertedTheme
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NoAccess);



// WEBPACK FOOTER //
// ./src/containers/NoAccessContainer.js